import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-item-in',
  templateUrl: './item-in.component.html',
  styleUrls: ['./item-in.component.scss']
})
export class ItemInComponent implements OnInit {

  title : string = "إذن إضافة";
  type :string =  "in";
  isInventory : boolean = false;
  
  constructor() { }

  ngOnInit() {
  }

}
